// src/components/UI/PrimaryButton.jsx
import React from 'react';
import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';

const MotionText = motion(Text);

const PrimaryButton = ({ children, icon, ...rest }) => {
  return (
    <Button
      as={motion.button}
      whileHover="hover"
      variant="solid" // Usa a variante do seu theme.js
      w="full"
      h="3rem"
      p="0.75rem"
      overflow="hidden"
      {...rest}
    >
      <Flex w="full" align="center" justify="space-between">
        <MotionText
          w="80%"
          textAlign="left"
          fontWeight="bold"
          variants={{
            hover: { x: 20 },
          }}
          transition={{ type: 'spring', stiffness: 300 }}
        >
          {children}
        </MotionText>
        <Flex w="20%" justify="center" align="center">
          <Icon as={icon || FaArrowRight} />
        </Flex>
      </Flex>
    </Button>
  );
};

export default PrimaryButton;